var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"aria-hidden":"true","focusable":"false","role":"img","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }